// extracted by mini-css-extract-plugin
module.exports = {"container":"Actions_container__1SgcF","header":"Actions_header__2G7G-","body":"Actions_body__KVk8Q"};